import React from 'react';
import { SFLaurelLeading } from 'sf-symbols-lib/monochrome/SFLaurelLeading';
import { SFLaurelTrailing } from 'sf-symbols-lib/monochrome/SFLaurelTrailing';
import RevealBlock from '../components/RevealBlock';
import './HeroBanner.css';

function HeroBanner() {
  return (
    <RevealBlock as="div" className="ayro-heroBanner">
      <div className="ayro-heroBanner__inner">
        <SFLaurelLeading className="ayro-heroBanner__laurel" aria-hidden="true" />
        <p>A must-have tool for high-performers and athletes</p>
        <SFLaurelTrailing className="ayro-heroBanner__laurel" aria-hidden="true" />
      </div>
    </RevealBlock>
  );
}

export default HeroBanner;
